const firebaseConfig = {
    apiKey: "AIzaSyCJrCDXK6kWF78UAMaHXGMxr0h_9sWTDK4",
    authDomain: "volunteer-network1.firebaseapp.com",
    databaseURL: "https://volunteer-network1.firebaseio.com",
    projectId: "volunteer-network1",
    storageBucket: "volunteer-network1.appspot.com",
    messagingSenderId: "904569415344",
    appId: "1:904569415344:web:f7ed24dc6f6788e96b7d75"
  };

  export default firebaseConfig;